import "../../assets/scss/base/pages/account/Voucher.scss";

// Components
import ShowMoreLessText from "../micro/ShowMoreLessText/ShowMoreLessText";

const AppliedVoucherCard = ({ voucher, discountAmount = 0, onRemove }) => {
    const normalizedVoucher =
        voucher?.Voucher || voucher?.voucher || voucher;

    const getRibbonText = () => {
        if (normalizedVoucher?.type === "Flat") {
            return `RM ${normalizedVoucher?.typeValue} OFF`;
        }
        if (normalizedVoucher?.type === "Percentage") {
            return `${normalizedVoucher?.typeValue}% OFF`;
        }
        return "APPLIED";
    };

    // Get seller/vendor display
    const getSellerDisplay = () => {
        if (normalizedVoucher.forAllVendors) {
            return "Pineapple.my";
        }

        if (Array.isArray(normalizedVoucher.vendors) && normalizedVoucher.vendors.length > 0) {
            return normalizedVoucher.vendors
                .map(vendor => vendor.companyName)
                .join(", ");
        }

        return "N/A";
    };

    return (
        <div className="voucher-card-ui applied-voucher-ui">
            {/* LEFT RIBBON */}
            <div className="voucher-ribbon">
                <span>{getRibbonText()}</span>
            </div>

            {/* RIGHT CONTENT */}
            <div className="voucher-content">
                <div className="voucher-header-ui applied-header">
                    <h3 className="voucher-title-ui" >
                        {normalizedVoucher?.code?.length > 27
                            ? normalizedVoucher.code.slice(0, 27) + "..."
                            : normalizedVoucher?.code}
                    </h3>

                    <span className="voucher-applied-status">Applied</span>
                </div>

                <p className="voucher-save-ui">
                    Save RM {Number(discountAmount).toFixed(2)} on this order!
                </p>

                <div className="voucher-divider" />

                <p className="voucher-seller-ui">
                    Seller : <span>{getSellerDisplay()}</span>
                </p>

                <div className="voucher__item__details__block">
                    <ShowMoreLessText
                        text={normalizedVoucher?.description}
                        maxLength={100}
                    />
                </div>

                <div className="applied-voucher-footer">
                    <span>  </span>
                    <span
                        className="applied-voucher-remove"
                        onClick={() => onRemove?.(normalizedVoucher)}
                    >
                        Remove
                    </span>
                </div>
            </div>
        </div>
    );
};

export default AppliedVoucherCard;
